import { localQueryKey } from "hooks/useTypedQuery";
import { UserAcls } from "modules/Auth/services";

const component = "Auth";

interface TokenStatus {
  isExpired: boolean;
}

export class Auth {
  token: string = "";
  expire_at: string = "";
}

export const AuthKeys = {
  auth: localQueryKey<Auth>({ component, data: "auth" }),
  user: localQueryKey<UserAcls | null>({ component, data: "user" }),
  tokenStatus: localQueryKey<TokenStatus>({ component, data: "tokenStatus" })
};
